import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { cn } from "@/lib/utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, onWheel, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin]",
        className
      )}
      // A Popover's content is portalled to document.body, a separate DOM
      // subtree from any open Dialog/Sheet's own "shard" - react-remove-
      // scroll (which Dialog/Sheet use to lock body scroll) only exempts
      // scroll targets inside that shard from its global, capture-phase
      // `wheel` listener, and calls event.preventDefault() on everything
      // else unconditionally (it never even checks whether the target
      // itself can scroll - see react-remove-scroll's SideEffect.js
      // shouldPrevent). That silently breaks mouse-wheel scrolling inside
      // every dropdown/combobox opened from within a Dialog or Sheet
      // anywhere in the app. Scrolling the nearest scrollable ancestor
      // manually here bypasses that global block entirely, since we no
      // longer depend on the browser's native (and now-blocked) scroll.
      onWheel={(e) => {
        onWheel?.(e);
        if (e.defaultPrevented) return;
        const scrollable = (e.target as HTMLElement).closest<HTMLElement>(
          "[data-radix-scroll-area], [cmdk-list]"
        );
        if (scrollable) scrollable.scrollTop += e.deltaY;
      }}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
